import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Container, Flex, Grid } from '@chakra-ui/react';
import { BB_MENU_IDS } from '@whitbread-eos/api';
import { Icon, Logo } from '@whitbread-eos/atoms';
import { formatAssetsUrl, getAuthCookie, getLoggedInUserInfo, getSecureTwoURL, useCompanyDetails, isStringValid, useCustomLocale, useUserData, useUserDetails, formatForMobile, superRoleFilter, langFilter } from '@whitbread-eos/utils';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { getListOfLanguagesForSwitcher } from '../../helpers/helpers';
import { containerLogoStyle, containerWrapperStyles, contentStyles, headerWrapperStyles } from '../HeaderBusiness.style';
import BBNavigationMenu from '../NavigationMenu';
import BBNavigationMenuMobile from '../NavigationMenuMobile';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function HeaderBusinessVariantDefault(_ref) {
  var _content$authenticati, _content$menu, _content$menu3, _content$menu4, _content$header;
  var BBHeaderInfo = _ref.BBHeaderInfo;
  var content = BBHeaderInfo.content,
    config = BBHeaderInfo.config;
  var _useCustomLocale = useCustomLocale(),
    language = _useCustomLocale.language,
    country = _useCustomLocale.country;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    origin = _useState2[0],
    setOrigin = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    languagesList = _useState4[0],
    setLanguagesList = _useState4[1];
  var _useState5 = useState(true),
    _useState6 = _slicedToArray(_useState5, 2),
    isLoading = _useState6[0],
    setIsLoading = _useState6[1];
  var router = useRouter();
  var isWindowDefined = typeof window !== 'undefined';
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    mappedNavigationLabels = _useState8[0],
    setMappedNavigationLabels = _useState8[1];
  var _useUserData = useUserData(),
    isLoggedIn = _useUserData.isLoggedIn;
  var business = useUserDetails(true, isLoggedIn) || {};
  var idTokenCookie = getAuthCookie();
  var _getLoggedInUserInfo = getLoggedInUserInfo(idTokenCookie),
    accessLevel = _getLoggedInUserInfo.accessLevel,
    cdhCompanyId = _getLoggedInUserInfo.cdhCompanyId,
    sessionId = _getLoggedInUserInfo.sessionId,
    cdhEmployeeId = _getLoggedInUserInfo.cdhEmployeeId;
  var _ref2 = useCompanyDetails(cdhCompanyId, sessionId, cdhEmployeeId, isLoggedIn) || {},
    requestedCompany = _ref2.requestedCompany;
  var logoutLabel = content === null || content === void 0 || (_content$authenticati = content.authentication) === null || _content$authenticati === void 0 ? void 0 : _content$authenticati.logoutButton;
  var isLogoutButton = title => title === logoutLabel;
  var homeBB = "".concat(origin, "/").concat(country, "/").concat(language, "/business-booker/home.html");
  var tickIconSrc = content === null || content === void 0 || (_content$menu = content.menu) === null || _content$menu === void 0 ? void 0 : _content$menu.tick;
  var tickIcon = _jsx(Icon, {
    src: formatAssetsUrl(tickIconSrc),
    color: "var(--chakra-colors-primary)"
  });
  var isLanguageListLoaded = !isLoading && !!languagesList;
  var countries = content === null || content === void 0 ? void 0 : content.countries;
  useEffect(() => {
    setOrigin(window.location.origin);
  }, [isWindowDefined]);
  useEffect(() => {
    var handleMessages = message => {
      if ((message === null || message === void 0 ? void 0 : message.origin) === getSecureTwoURL()) {
        var _message$data;
        var action = typeof (message === null || message === void 0 ? void 0 : message.data) === 'string' ? message.data : (_message$data = message.data) === null || _message$data === void 0 ? void 0 : _message$data.action;
        if (action === 'userLoggedOut') {
          router.push(homeBB);
        }
      }
    };
    window.addEventListener('message', handleMessages);
    return () => {
      window.removeEventListener('message', handleMessages);
    };
  }, [homeBB, router]);
  useEffect(() => {
    if (!content || !config || !isStringValid(idTokenCookie) || !requestedCompany || !business) {
      return;
    }
    var _content$subNav$filte = content.subNav.filter(item => item.title === BB_MENU_IDS.BUSINESS_ACCOUNT),
      _content$subNav$filte2 = _slicedToArray(_content$subNav$filte, 1),
      businessAccountOptions = _content$subNav$filte2[0];
    var businessAccountMenu = language !== 'de' ? {
      navOptions: businessAccountOptions === null || businessAccountOptions === void 0 ? void 0 : businessAccountOptions.navOptions.map(navOption => {
        if (!navOption.title.includes(BB_MENU_IDS.ACCOUNT_DASHBOARD)) {
          return navOption;
        } else if (navOption.title.includes(BB_MENU_IDS.ACCOUNT_DASHBOARD) && business !== null && business !== void 0 && business.tethered) {
          return {
            title: navOption.title,
            url: navOption.url,
            superRole: true
          };
        }
      }).filter(navOption => navOption),
      title: businessAccountOptions === null || businessAccountOptions === void 0 ? void 0 : businessAccountOptions.title
    } : null;
    var mappedCompanyMenu = {
      navOptions: [...config.authentication.accountLinks, ...config.authentication.business.businessAccountLinks.map(item => _objectSpread(_objectSpread({}, item), {}, {
        superRole: true
      })), {
        title: logoutLabel
      }],
      title: BB_MENU_IDS.COMPANY_DETAILS
    };
    if (!mappedNavigationLabels.length) {
      var _content$menu2, _content$subNav, _requestedCompany$com;
      var navItems = [{
        navTitle: content === null || content === void 0 || (_content$menu2 = content.menu) === null || _content$menu2 === void 0 ? void 0 : _content$menu2.business,
        subNav: content === null || content === void 0 || (_content$subNav = content.subNav) === null || _content$subNav === void 0 ? void 0 : _content$subNav.filter(item => item.title === BB_MENU_IDS.BUSINESS_CUSTOMERS),
        id: BB_MENU_IDS.ABOUT
      }, {
        navTitle: businessAccountMenu === null || businessAccountMenu === void 0 ? void 0 : businessAccountMenu.title,
        subNav: superRoleFilter(accessLevel, [businessAccountMenu]),
        id: BB_MENU_IDS.BUSINESS
      }, {
        navTitle: (requestedCompany === null || requestedCompany === void 0 || (_requestedCompany$com = requestedCompany.companyDetails) === null || _requestedCompany$com === void 0 ? void 0 : _requestedCompany$com.companyName) || '',
        subNav: superRoleFilter(accessLevel, [mappedCompanyMenu]),
        id: BB_MENU_IDS.COMPANY
      }];
      setMappedNavigationLabels(langFilter(language, navItems));
    }
  }, [accessLevel, content, config, idTokenCookie, requestedCompany, language, logoutLabel, isLoggedIn, mappedNavigationLabels, business]);
  useEffect(() => {
    if ((countries === null || countries === void 0 ? void 0 : countries.length) > 0) {
      setLanguagesList(getListOfLanguagesForSwitcher(countries));
      setIsLoading(false);
    }
  }, [countries]);
  var genericLabels = {
    language: content === null || content === void 0 || (_content$menu3 = content.menu) === null || _content$menu3 === void 0 ? void 0 : _content$menu3.language,
    mobileMenuButton: content === null || content === void 0 || (_content$menu4 = content.menu) === null || _content$menu4 === void 0 ? void 0 : _content$menu4.mobileMenuButton
  };
  return _jsx(Box, _objectSpread(_objectSpread({}, headerWrapperStyles), {}, {
    "data-testid": "HeaderBusiness",
    children: _jsx(Container, _objectSpread(_objectSpread({}, containerWrapperStyles(language)), {}, {
      children: _jsxs(Grid, _objectSpread(_objectSpread({}, contentStyles), {}, {
        sx: {
          '@media print': {
            py: 'sm'
          }
        },
        children: [_jsx(Flex, _objectSpread(_objectSpread({}, containerLogoStyle), {}, {
          "data-testid": "logo-container",
          children: _jsx(Logo, {
            href: homeBB,
            src: formatAssetsUrl(content === null || content === void 0 || (_content$header = content.header) === null || _content$header === void 0 ? void 0 : _content$header.image),
            variant: 'pi-icon'
          })
        })), _jsx(Grid, {
          templateColumns: "1fr auto",
          display: {
            mobile: 'none',
            lg: 'grid'
          },
          sx: {
            '@media print': {
              display: 'none'
            }
          },
          children: isLanguageListLoaded && _jsx(BBNavigationMenu, {
            navigationLabels: mappedNavigationLabels,
            languageMenuLabels: languagesList,
            language: language,
            tickIcon: tickIcon,
            dataTestId: "HeaderBusiness",
            isLogoutButton: isLogoutButton
          })
        }), _jsx(Grid, {
          display: {
            mobile: 'grid',
            lg: 'none'
          },
          justifyContent: 'end',
          children: isLanguageListLoaded && _jsx(BBNavigationMenuMobile, {
            navigationLabels: formatForMobile(mappedNavigationLabels),
            languageMenuLabels: languagesList,
            language: language,
            tickIcon: tickIcon,
            isLogoutButton: isLogoutButton,
            genericLabels: genericLabels
          })
        })]
      }))
    }))
  }));
}